












import { Component, Prop, Vue } from 'vue-property-decorator';
import Title from '../title';

@Component({
  components: {
    Title,
  },
})
export default class Links extends Vue {
  @Prop({ type: String, default: '' })
  readonly title!: string;

  @Prop({ type: Array, default: () => [] })
  readonly links!: Array<any>;

  get linkAndDescription() {
    return this.links.filter(
      ({ link, description }) => link.length || description.length
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/components/info/components/block/components/itemsblock/components/links/Links.vue